import { useMemo } from 'react';

import type { Simulation } from '@/routes/(app)/(scenarios)/types';
import {
  addMedianToRows,
  buildMedianLine,
  buildSimulationLines,
  buildWeekendRegions,
  pivotSimulationsByDate,
} from '@/routes/(app)/(scenarios)/utils/scenario.utils';

export interface UseOccupancyChartProps {
  showSeriesNames?: boolean;
  showMedian?: boolean;
  showValueLabels?: boolean;
}

export function useOccupancyChart(
  simulations: Array<Simulation>,
  options?: UseOccupancyChartProps
) {
  const { showSeriesNames, showMedian, showValueLabels } = options ?? {};

  const data = useMemo(() => {
    const rows = pivotSimulationsByDate(simulations);
    return showMedian ? addMedianToRows(rows) : rows;
  }, [simulations, showMedian]);

  const lines = useMemo(() => {
    const simulationLines = buildSimulationLines({
      simulations,
      options: {
        showSeriesNames,
        mutedColors: showMedian,
        showValueLabels,
      },
    });
    return showMedian
      ? [...simulationLines, buildMedianLine()]
      : simulationLines;
  }, [simulations, showSeriesNames, showMedian, showValueLabels]);
  const regions = useMemo(() => buildWeekendRegions(data), [data]);

  return { data, lines, regions };
}
